<template>
  <svg
    width="160"
    height="160"
    viewBox="0 0 160 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.06"
      d="M79.8819 140C112.953 140 139.764 113.189 139.764 80C139.764 46.811 112.835 20 79.8819 20C46.811 20 20 46.811 20 80C20 113.189 46.811 140 79.8819 140Z"
      fill="url(#paint0_linear_10073_72579)"
    />
    <g filter="url(#filter0_d_10073_72579)">
      <rect
        x="81.5913"
        y="39.0928"
        width="57.8519"
        height="74.1006"
        rx="4"
        transform="rotate(10 81.5913 39.0928)"
        fill="url(#paint1_linear_10073_72579)"
      />
    </g>
    <rect
      opacity="0.24"
      x="79.9722"
      y="96.8621"
      width="40.9784"
      height="8.46395"
      rx="3"
      transform="rotate(10 79.9722 96.8621)"
      fill="url(#paint2_linear_10073_72579)"
    />
    <path
      opacity="0.2"
      d="M82.0718 84.9546L121.834 91.9658"
      stroke="url(#paint3_linear_10073_72579)"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      opacity="0.2"
      d="M83.1421 78.8828L122.904 85.894"
      stroke="url(#paint4_linear_10073_72579)"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M81.0698 90.6362L104.215 94.7174"
      stroke="#D6DCE8"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <rect
      opacity="0.04"
      x="82.4858"
      y="40.7202"
      width="55.4414"
      height="29.5716"
      rx="4"
      transform="rotate(10 82.4858 40.7202)"
      fill="url(#paint5_linear_10073_72579)"
    />
    <path
      d="M111.038 56.717C111.707 56.8349 112.348 56.3638 112.471 55.6649C112.595 54.966 112.153 54.3039 111.485 54.186C110.816 54.0682 110.175 54.5392 110.051 55.2382C109.928 55.9371 110.37 56.5992 111.038 56.717Z"
      fill="#D6DCE8"
    />
    <path
      d="M109.661 64.9461L100.428 63.3182C99.8328 63.2132 99.6128 62.4291 100.042 62.0256L105.842 56.1274C106.212 55.7668 106.808 55.8718 107.033 56.3374L110.466 63.8636C110.722 64.4412 110.256 65.0511 109.661 64.9461Z"
      fill="#D6DCE8"
    />
    <path
      opacity="0.7"
      d="M112.899 65.376L108.355 64.5748C107.665 64.4531 107.452 63.6418 107.889 63.1831L110.692 60.4035C111.118 60.0025 111.751 60.114 112.015 60.6367L113.698 64.2074C114.124 64.8182 113.589 65.4977 112.899 65.376Z"
      fill="#D6DCE8"
    />
    <g filter="url(#filter1_d_10073_72579)">
      <rect
        x="21.6577"
        y="49.1387"
        width="57.8519"
        height="74.1006"
        rx="4"
        transform="rotate(-10 21.6577 49.1387)"
        fill="url(#paint6_linear_10073_72579)"
      />
    </g>
    <rect
      opacity="0.24"
      x="39.8955"
      y="103.978"
      width="40.9784"
      height="8.46395"
      rx="3"
      transform="rotate(-10 39.8955 103.978)"
      fill="url(#paint7_linear_10073_72579)"
    />
    <path
      opacity="0.2"
      d="M37.7959 92.0701L77.5583 85.0589"
      stroke="url(#paint8_linear_10073_72579)"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      opacity="0.2"
      d="M36.7251 85.9985L76.4875 78.9874"
      stroke="url(#paint9_linear_10073_72579)"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      opacity="0.2"
      d="M38.7974 97.752L61.9426 93.6708"
      stroke="url(#paint10_linear_10073_72579)"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <rect
      opacity="0.04"
      x="23.0547"
      y="50.1204"
      width="55.4414"
      height="29.5716"
      rx="4"
      transform="rotate(-10 23.0547 50.1204)"
      fill="url(#paint11_linear_10073_72579)"
    />
    <path
      d="M55.3903 55.6228C56.0586 55.505 56.5005 54.8428 56.3773 54.1439C56.254 53.445 55.6123 52.974 54.944 53.0918C54.2757 53.2096 53.8338 53.8718 53.957 54.5707C54.0803 55.2696 54.722 55.7407 55.3903 55.6228Z"
      fill="#D6DCE8"
    />
    <path
      d="M56.9103 63.8268L47.6781 65.4546C47.0824 65.5597 46.6075 64.8981 46.873 64.3721L50.3056 56.846C50.5306 56.3804 51.1262 56.2754 51.4968 56.6359L57.2965 62.5342C57.735 62.9893 57.5059 63.7217 56.9103 63.8268Z"
      fill="url(#paint12_linear_10073_72579)"
    />
    <path
      opacity="0.7"
      d="M60.0994 63.1232L55.5557 63.9243C54.8655 64.046 54.3881 63.3564 54.6416 62.776L56.3248 59.2053C56.5885 58.6826 57.2211 58.5711 57.6477 58.9721L60.4506 61.7517C61.0599 62.18 60.7896 63.0015 60.0994 63.1232Z"
      fill="#D6DCE8"
    />
    <g filter="url(#filter2_d_10073_72579)">
      <rect
        x="48.8281"
        y="40.1838"
        width="64.7033"
        height="82.4871"
        rx="4"
        fill="url(#paint13_linear_10073_72579)"
      />
    </g>
    <rect
      opacity="0.24"
      x="58.2646"
      y="103.828"
      width="45.8315"
      height="9.42188"
      rx="3"
      fill="url(#paint14_linear_10073_72579)"
    />
    <path
      opacity="0.2"
      d="M58.2646 90.3677H103.422"
      stroke="url(#paint15_linear_10073_72579)"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      opacity="0.2"
      d="M58.2646 83.5046H103.422"
      stroke="url(#paint16_linear_10073_72579)"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      opacity="0.2"
      d="M58.2646 96.7898H84.5503"
      stroke="url(#paint17_linear_10073_72579)"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <rect
      opacity="0.04"
      x="50.1772"
      y="41.5298"
      width="62.0073"
      height="32.9184"
      rx="4"
      fill="url(#paint18_linear_10073_72579)"
    />
    <path
      d="M84.7933 53.8128C85.5523 53.8128 86.1676 53.1724 86.1676 52.3824C86.1676 51.5923 85.5523 50.9519 84.7933 50.9519C84.0342 50.9519 83.4189 51.5923 83.4189 52.3824C83.4189 53.1724 84.0342 53.8128 84.7933 53.8128Z"
      fill="url(#paint19_linear_10073_72579)"
    />
    <path
      d="M84.873 63.1005H74.3882C73.7117 63.1005 73.3171 62.2834 73.7117 61.7581L78.9542 54.171C79.2924 53.7041 79.9688 53.7041 80.307 54.171L85.5495 61.7581C85.9441 62.3417 85.5495 63.1005 84.873 63.1005Z"
      fill="url(#paint20_linear_10073_72579)"
    />
    <path
      opacity="0.5"
      d="M88.5231 62.9455H83.3629C82.579 62.9455 82.1871 62.0972 82.579 61.5099L85.1265 57.9208C85.5184 57.3988 86.2369 57.3988 86.6288 57.9208L88.9806 61.2342C89.1108 61.4176 89.2771 61.5799 89.371 61.7843C89.6216 62.3298 89.1909 62.9455 88.5231 62.9455Z"
      fill="url(#paint21_linear_10073_72579)"
    />
    <defs>
      <filter
        id="filter0_d_10073_72579"
        x="47.3569"
        y="28.7258"
        width="112.574"
        height="125.754"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10073_72579"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10073_72579"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_10073_72579"
        x="0.291016"
        y="28.7261"
        width="112.574"
        height="125.754"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10073_72579"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10073_72579"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_10073_72579"
        x="26.8281"
        y="29.1838"
        width="108.703"
        height="126.487"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10073_72579"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10073_72579"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_10073_72579"
        x1="19.9981"
        y1="139.999"
        x2="139.998"
        y2="20.235"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10073_72579"
        x1="110.498"
        y1="37.3788"
        x2="110.498"
        y2="113.992"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_10073_72579"
        x1="79.9715"
        y1="105.326"
        x2="83.3249"
        y2="89.0906"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_10073_72579"
        x1="81.8975"
        y1="85.9393"
        x2="82.2933"
        y2="83.9795"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_10073_72579"
        x1="82.9678"
        y1="79.8675"
        x2="83.3637"
        y2="77.9077"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_10073_72579"
        x1="82.485"
        y1="70.2916"
        x2="107.044"
        y2="24.2477"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_10073_72579"
        x1="50.5648"
        y1="47.4247"
        x2="50.5648"
        y2="124.038"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_10073_72579"
        x1="39.8949"
        y1="112.442"
        x2="43.2482"
        y2="96.2063"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_10073_72579"
        x1="37.9689"
        y1="93.055"
        x2="37.6706"
        y2="91.078"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_10073_72579"
        x1="36.8981"
        y1="86.9834"
        x2="36.5998"
        y2="85.0064"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_10073_72579"
        x1="38.9706"
        y1="98.7368"
        x2="38.7076"
        y2="96.756"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_10073_72579"
        x1="23.0538"
        y1="79.6918"
        x2="47.6129"
        y2="33.6478"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_10073_72579"
        x1="46.944"
        y1="65.584"
        x2="53.0512"
        y2="53.8506"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_10073_72579"
        x1="81.1587"
        y1="38.2758"
        x2="81.1587"
        y2="123.56"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_10073_72579"
        x1="58.2639"
        y1="113.249"
        x2="61.9807"
        y2="95.1697"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_10073_72579"
        x1="58.2639"
        y1="91.3677"
        x2="58.3082"
        y2="89.3686"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_10073_72579"
        x1="58.2639"
        y1="84.5046"
        x2="58.3082"
        y2="82.5056"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_10073_72579"
        x1="58.2642"
        y1="97.7898"
        x2="58.3402"
        y2="95.7927"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0855C5" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_10073_72579"
        x1="50.1763"
        y1="74.448"
        x2="77.4431"
        y2="23.0863"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_10073_72579"
        x1="83.4189"
        y1="53.8128"
        x2="86.2775"
        y2="51.0664"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_10073_72579"
        x1="73.5545"
        y1="63.1004"
        x2="82.5067"
        y2="51.3773"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_10073_72579"
        x1="82.4252"
        y1="62.9454"
        x2="87.6645"
        y2="56.1566"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup></script>
